// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { DataStream } from './DataStream.js'
export let  SocketDataStream = function (ws, delegates)
{
    DataStream.call(this, delegates.OnMessageDelegate);

    this.StreamOpened = false;

    this.OnOpenDelegate = delegates.OnOpenDelegate;
    this.OnCloseDelegate = delegates.OnCloseDelegate;
    this.OnErrorDelegate = delegates.OnErrorDelegate;

    ws.onopen = this.onopen.bind(this);
    ws.onclose = this.onclose.bind(this);
    ws.onmessage = this.onmessage.bind(this);
    ws.onerror = this.onerror.bind(this);

    this.ws = ws;
}
SocketDataStream.prototype = Object.create(DataStream.prototype);

SocketDataStream.prototype.onmessage = function (evt)
{
    if (this.OnMessageDelegate !== null)
        this.OnMessageDelegate(evt.data);
}
SocketDataStream.prototype.onopen = function ()
{
    this.StreamOpened = true;
    if (this.OnOpenDelegate)
        this.OnOpenDelegate(true);
}
SocketDataStream.prototype.onclose = function (evt)
{
    if (evt.code !== 1000)
        this.onerror(evt);

    this.StreamOpened = false;
    if (this.OnCloseDelegate)
        this.OnCloseDelegate();
}
SocketDataStream.prototype.onerror = function (evt)
{
    if (this.OnErrorDelegate)
        this.OnErrorDelegate(false);
    this.Dispose();
}

SocketDataStream.prototype.Dispose = function ()
{
    if (!this.ws)
        return;
    this.StreamOpened = false;
    this.ws.onopen = null;
    this.ws.onclose = null;
    this.ws.onmessage = null;
    this.ws.onerror = null;
    this.OnOpenDelegate = null;
    this.OnCloseDelegate = null;
    this.OnErrorDelegate = null;
    this.ws.close();
    this.ws = null;
}

SocketDataStream.prototype.CloseStream = function ()
{
    if (!this.ws)
        return;
    this.StreamOpened = false;
    this.ws.onopen = null;
    this.ws.onclose = null;
    this.ws.onmessage = null;
    this.ws.onerror = null;
    this.OnOpenDelegate = null;
    this.OnCloseDelegate = null;
    this.OnErrorDelegate = null;
    this.ws.close();
    this.ws = null;
}

SocketDataStream.prototype.Connected = function ()
{
    return this.StreamOpened;
}

SocketDataStream.prototype.SendData = function (message)
{
    if (this.Connected())
        this.ws.send(message);
    //else
    //    this.Dispose();
}